import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import VerticalBarChart from "../common/vericalBarChart.js";
import "./feedbackChart.scss";
import { useDispatch, useSelector } from "react-redux";
import { ReduxFeedback } from "../../redux/feature/feedback";
import api_call from "../../globals/common_utilities/axios_old";
import CONSTANTS from "../../globals/common_utilities/constant";
import { API, STATUS, ROLE } from "../../globals/constants/index";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import Button from "../common/Button";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";
import Cookies from "universal-cookie";
import CsvDownloader from "react-csv-downloader";

const FeedBackChart = (props) => {
  const [showLoader, setShowLoader] = useState(false);
  const [exportData, setExportData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const cookies = new Cookies();
  const { email_id, token, role_code, name, studio_id, id } =
    cookies.get("loginData");
  const [view_feedback_api_res, set_view_feedback_api_res] = useState();
  console.log("view_feedback_api_res-------->>", view_feedback_api_res);

  const getChart = async () => {
    let params = { training_id: state.array_1.id };
    console.log("Inside Get Chart");
    setShowLoader(true);
    let res = await api_call(
      "POST",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].FEEDBACK +
        API.END_POINTS.FEEDBACK_RESPONSE
      }`,
      // "https://45nqltb6r4.execute-api.ap-south-1.amazonaws.com/dev/api/v1/view-feedback-response",
      {},
      {},
      params
    );
    setShowLoader(false);

    if (res.status === 200) {
      set_view_feedback_api_res(res?.data?.data);
    } else {
      set_view_feedback_api_res([]);
    }
  };
  const downloadPdfDocument = () => {
    return () => {
      document.getElementById("export_csv").click();
    };
  };
  const loadGraphExport = async () => {
    console.log("loadGraphExport", loadGraphExport);
    let response = await api_call(
      "GET",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].FEEDBACK +
        API.END_POINTS.GET_EXPORTVIEWFEEDBACK
      }`,
      {
        unique_id: role_code === "STUDIO_ADMIN" ? studio_id : id,
        is_export: true,
        tid: state.array_1.id,
      },
      {},
      {}
    );
    if (response.status === 200) {
      let data = response.data.data.users_trainings;
      let title = response.data.data.title;
      if (response.data.data.users_trainings) {
        let graphExp = [];
        response.data.data.users_trainings.forEach((result) => {
          let tempData = {
            ["Training Name"]: title || "",
            ["Student Name"]: result?.student?.name || "",
          };
          if (result?.student?.feedback_responses?.length > 0) {
            let temp2 = [
              ...result?.student?.feedback_responses[0]?.feedback_answers,
            ];
            temp2.forEach((value) => {
              let answer = "";
              if (value?.question_type == "star") {
                answer = value?.rating_answers;
              }
              if (value?.question_type == "radio") {
                answer = JSON.parse(value?.options);
              }
              if (value?.question_type == "checkbox") {
                answer = JSON.stringify(JSON.parse(value?.options).join("|"));
              }
              if (value?.question_type == "textbox") {
                answer = (value?.answer).split(",").join("");
              }
              let abc = {
                [(value?.question).split(",").join("")]: answer,
              };
              tempData = { ...tempData, ...abc };
            });
            if (
              result?.student?.feedback_responses[0]?.feedback_answers.length >
              0
            ) {
              graphExp.push(tempData);
            }
          }
        });
        // this.setState((prevState) => ({
        //   ...prevState,
        //   exportData: [...graphExp],
        // }));
        setExportData([...graphExp]);
      }
    }
  };
  useEffect(() => {
    getChart();
    loadGraphExport();
  }, []);

  return (
    <>
      {showLoader ? (
        <MultiLine_Spinner />
      ) : (
        <Box className="feedback_chart_container">
          {console.log("bnmbnbbnbn", state?.array_1)}
          <Grid container>
            <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
              <Box className="feeback_heading_container">
                <span
                  className="large_f_bold blue_color"
                  onClick={() => {
                    navigate("/feedback");
                  }}
                >
                  Feedback {">>"}
                </span>
                <span className="large_f_bold">
                  Training Name - {state?.array_1?.title}
                </span>
              </Box>
            </Grid>
            {exportData.length > 0 ? (
              <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                <CsvDownloader
                  className="d-none"
                  filename="Feedback_response"
                  separator=","
                  id="export_csv"
                  datas={exportData}
                >
                  {view_feedback_api_res?.question.length > 0 ? (
                    <Button
                      variant="primary"
                      id="file-drag"
                      role="default"
                      value="Export"
                      onClick={() => downloadPdfDocument}
                    />
                  ) : (
                    ""
                  )}
                </CsvDownloader>
              </Grid>
            ) : (
              ""
            )}
          </Grid>

          <Box className="feedback_body_container large_f">
            <Grid rowSpacing={4} container>
              {/* <Grid container justifyContent="center" item xs={12}>
              <Box className="larger_f">
                Training Name - {state?.array_1?.title}
              </Box>
            </Grid> */}
              {view_feedback_api_res?.question ? (
                <>
                  <Grid item xs={12}>
                    <Box className="chart_container">
                      <Grid container justifyContent="space-evenly">
                        <Box>
                          Total No. of Student -{" "}
                          {state?.array_2?.total_student_count}{" "}
                        </Box>
                        <Box>
                          Received - {view_feedback_api_res?.totalResponse}{" "}
                        </Box>

                        <Box>
                          Pending - {view_feedback_api_res?.pendingResponse}{" "}
                        </Box>
                      </Grid>
                    </Box>
                  </Grid>

                  {view_feedback_api_res?.question.map((data) => {
                    console.log("data----------->>>", data);
                    return (
                      <>
                        {data.question_type !== "textbox" && (
                          <Grid item xs={12}>
                            <Box className="chart_container">
                              <Box className="chart_question_container">
                                <Box>{data?.question}</Box>
                                <Box>
                                  {view_feedback_api_res?.totalResponse}{" "}
                                  Response
                                </Box>
                              </Box>
                              <div className="chart_height">
                                <VerticalBarChart data={data} />
                              </div>
                            </Box>
                          </Grid>
                        )}
                        {data.question_type === "textbox" && (
                          <Grid item xs={12}>
                            <Box className="chart_container">
                              <Box className="chart_question_container">
                                <Box>{data?.question}</Box>
                              </Box>
                              <Box className="chart_question_listing">
                                <Grid container rowSpacing={4}>
                                  {data.answers.map((val) => {
                                    return val?.student_answer?.answer ? (
                                      <Grid
                                        item
                                        container
                                        columnSpacing={2}
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="center"
                                      >
                                        <Grid
                                          item
                                          xs={3}
                                          container
                                          justifyContent="center"
                                        >
                                          {val?.student_name?.name}
                                        </Grid>
                                        <Grid item xs={9}>
                                          <Box className="chart_question_list">
                                            {val?.student_answer?.answer}
                                          </Box>
                                        </Grid>
                                      </Grid>
                                    ) : (
                                      ""
                                    );
                                  })}
                                </Grid>
                              </Box>
                            </Box>
                          </Grid>
                        )}
                      </>
                    );
                  })}
                </>
              ) : (
                <Grid container justifyContent={"center"}>
                  <h1 className="feedback_padding">No feedback received !!!</h1>
                </Grid>
              )}
            </Grid>
          </Box>
        </Box>
      )}
    </>
  );
};

export default FeedBackChart;
